/**
 * Component: Bambuser Button
 * -----------------------------------------------------------------------------
 * A standalone Custom Element used to interact with Bambuser/Live Shopping API.
 * @namespace BambuserButton
 */

/**
 * Create BambuserButton Class.
 */
export default class BambuserButton extends window.HTMLElement {

  /**
   * Initialise.
   */
  constructor () {
    super()

    this.showId = this.getAttribute('show-id')
  }

  /**
   * The element is now defined on the page, so run functionality.
   */
  connectedCallback() {
    this.initModalOpener()
  }

  initModalOpener() {
    const payload = {
      showId: this.showId,
      node: this,
      type: 'overlay',
    }

    mint.EventBus.dispatch('bambuser:initLiveShopping', payload)
  }
}
